import { render, staticRenderFns } from "./sourceTop.vue?vue&type=template&id=79894ba3&scoped=true"
import script from "./sourceTop.vue?vue&type=script&lang=js"
export * from "./sourceTop.vue?vue&type=script&lang=js"
import style0 from "./sourceTop.vue?vue&type=style&index=0&id=79894ba3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79894ba3",
  null
  
)

export default component.exports